import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getHeatingParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'heatingParts';

export const heatingPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearHeatingParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getHeatingParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearHeatingParts } = heatingPartsSlice.actions;

export const heatingParts = heatingPartsSlice.reducer;
